<template>
  <v-card class="px-6 pt-10 pb-6 my-8 white">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(validate)">
        <v-toolbar flat>
          <v-toolbar-title>
            {{ $t('serviceSettings.customService.sectionTitle') }}
          </v-toolbar-title>
          <v-spacer />
          <div>
            <v-btn text color="primary" type="submit" @click="handleConfigure">
              {{ $t('serviceSettings.customService.validate') }}
            </v-btn>
          </div>
        </v-toolbar>
        <v-row>
          <v-col class="pl-10" md="6">
            <ValidationProvider name="ServiceName" rules="required" v-slot="{ failedRules }">
              <v-text-field
                v-model="serviceName"
                class="ml-5"
                prepend-icon="mdi-format-align-bottom"
                :label="$t('serviceSettings.customService.serviceNamePlaceholder')"
                :error-messages="failedRules.required ? $t('serviceSettings.customService.emptyNameField') : ''"
              />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pl-10" md="6">
            <v-btn text v-bind:color="selectedColor ? 'secondary' : 'red'" @click="colorPicker = true">
              <v-icon>mdi-palette</v-icon>
              {{ $t('serviceSettings.customService.colorLabel') }}
              <div
                v-if="selectedColor"
                class="CustomServiceCreation-color ml-5"
                :style="`background: ${selectedColor};`"
              />
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pl-10" md="6">
            <v-btn text v-bind:color="selectedIcon ? 'secondary' : 'red'" @click="iconPicker = true">
              <v-icon>mdi-image</v-icon>
              {{ $t('serviceSettings.customService.iconLabel') }}
              <v-icon v-if="selectedIcon" class="ml-5">{{ selectedIcon }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <ColorPicker :isOpen="colorPicker" v-model="selectedColor" @close="colorPicker = false" />
        <IconPicker :isOpen="iconPicker" v-model="selectedIcon" @close="iconPicker = false" />
      </form>
      <div v-if="missingField && triedToFinish">
        <v-row>
          <v-col class="pl-10" md="6">
            <p style="color: red">{{ $t('serviceSettings.customService.fieldMissing') }}</p>
          </v-col>
        </v-row>
      </div>
      <v-alert
        v-if="serviceCreated"
        class="d-inline-block mt-3"
        dense
        text
        transition="slide-y-transition"
        type="success"
        :value="saved"
        >{{ $t('shop.savedSuccess') }}</v-alert
      >
    </ValidationObserver>
  </v-card>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import ColorPicker from './UI/ColorPicker.vue'
import IconPicker from './UI/IconPicker.vue'

export default {
  components: { ColorPicker, IconPicker, ValidationObserver, ValidationProvider },
  name: '',
  props: {
    shop: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      colorPicker: false,
      iconPicker: false,
      serviceName: '',
      selectedColor: '',
      selectedIcon: '',
      service: {},
      missingField: true,
      triedToFinish: false,
      serviceCreated: false
    }
  },

  methods: {
    handleConfigure() {
      this.$gtm.trackEvent({
        event: 'custom_service_configured',
        practitioner_id: this.$store.state.myUser.ecpId,
        shopUuid: this.$store.state.currentShopUuid
      })
    },
    validate() {
      if (this.selectedColor === '' || this.selectedIcon === '') {
        this.missingField = true
        this.triedToFinish = true
        return
      }
      this.missingField = false
      this.triedToFinish = true

      this.service = {
        color: this.selectedColor,
        duration: 30,
        icon: this.selectedIcon,
        name: this.serviceName,
        parallelAppointment: 5,
        price: 20.0,
        serviceType: 'custom',
        openings: {}
      }
      this.$emit('createService', this.service)
      this.serviceCreated = true
    }
  }
}
</script>

<style lang="scss" scoped>
.CustomServiceCreation-colorContainer {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}

.CustomServiceCreation-color {
  height: 20px;
  width: 20px;
  border-radius: 50%;
}
</style> 